export type SalsaExperimentVariant = {
  key: string;
  weight?: number;
};

type SalsaAnalyticsApi = {
  track: (eventType: string, payload?: Record<string, unknown>) => void;
  experiment: (
    experimentKey: string,
    variants: Array<string | SalsaExperimentVariant>,
    payload?: Record<string, unknown>
  ) => string | null;
  conversion: (experimentKey: string, goal: string, payload?: Record<string, unknown>) => boolean;
  flush: () => void;
};

declare global {
  interface Window {
    SalsaAnalytics?: SalsaAnalyticsApi;
  }
}

export const HOMEPAGE_HERO_EXPERIMENT = 'homepage-hero-v1';

export const trackEvent = (eventType: string, payload: Record<string, unknown> = {}) => {
  window.SalsaAnalytics?.track(eventType, payload);
};

export const assignExperiment = <Variant extends string>(
  experimentKey: string,
  variants: readonly Variant[],
  payload: Record<string, unknown> = {}
): Variant | null => {
  const experiment = window.SalsaAnalytics?.experiment;
  if (typeof experiment !== 'function') return null;
  const assignment = experiment(experimentKey, [...variants], payload);
  return assignment && variants.includes(assignment as Variant) ? (assignment as Variant) : null;
};

export const trackExperimentConversion = (
  experimentKey: string,
  goal: string,
  payload: Record<string, unknown> = {}
) => {
  const conversion = window.SalsaAnalytics?.conversion;
  return typeof conversion === 'function' ? conversion(experimentKey, goal, payload) : false;
};
